module.exports = __webpack_public_path__ + "img/gmp_badge@2x.c49aa29b.png";